import { BrandBgEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomBrandBgCreate2VO,
  RoomBrandBgDeleteVO,
  RoomBrandBgUnUseVO,
  RoomBrandBgUseVO
} from "@youm-front/room/domain";

export const roomBrandBgCreate = createAction(
  "[Room] Room Brand Bg Create",
  props<{ roomBrandBgCreateVO: RoomBrandBgCreate2VO }>()
);
export const roomBrandBgCreateSuccess = createAction(
  "[Room] Room Brand Bg Create Success",
  props<{ brandBg: BrandBgEntity }>()
);
export const roomBrandBgCreateFailure = createAction(
  "[Room] Room Brand Bg Create Failure",
  props<{ error: string }>()
);

export const roomBrandBgDelete = createAction(
  "[Room] Room Brand Bg Delete",
  props<{ roomBrandBgDeleteVO: RoomBrandBgDeleteVO }>()
);
export const roomBrandBgDeleteSuccess = createAction(
  "[Room] Room Brand Bg Delete Success",
  props<{ brandBg: BrandBgEntity }>()
);
export const roomBrandBgDeleteFailure = createAction(
  "[Room] Room Brand Bg Delete Failure",
  props<{ error: string }>()
);

export const roomBrandBgUnUse = createAction(
  "[Room] Room Brand Bg Un Use",
  props<{ roomBrandBgUnUseVO: RoomBrandBgUnUseVO }>()
);
export const roomBrandBgUnUseSuccess = createAction(
  "[Room] Room Brand Bg Un Use Success",
  props<{ brandBg: BrandBgEntity }>()
);
export const roomBrandBgUnUseFailure = createAction(
  "[Room] Room Brand Bg Un Use Failure",
  props<{ error: string }>()
);

export const roomBrandBgUse = createAction(
  "[Room] Room Brand Bg Use",
  props<{ roomBrandBgUseVO: RoomBrandBgUseVO }>()
);
export const roomBrandBgUseSuccess = createAction(
  "[Room] Room Brand Bg Use Success",
  props<{ brandBg: BrandBgEntity }>()
);
export const roomBrandBgUseFailure = createAction(
  "[Room] Room Brand Bg Use Failure",
  props<{ error: string }>()
);
